export default __webpack_public_path__ + "e6561c4d31cf5600f06ce0e2827206ea.svg";